import React, { memo, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import { isNormalZhEnCss, backTo, isMath } from '../../utils';
import styles from './styles.module.scss';
import frameIcon from '../../assets/img/public/frameicon.svg';
import frameMIcon from '../../assets/img/public/frameiconm.svg';
import frameicomMax from '../../assets/img/public/frameicomMax.svg';

import rectangleLeftTop from '../../assets/img/public/icons/rectangle/rectangleLeftTop.svg';
import rectangleLeftBottom from '../../assets/img/public/icons/rectangle/rectangleLeftBottom.svg';
import rectangleRightTop from '../../assets/img/public/icons/rectangle/rectangleRightTop.svg';
import rectangleRightBottom from '../../assets/img/public/icons/rectangle/rectangleRightBottom.svg';
import rectangleConter from '../../assets/img/public/icons/rectangle/rectangleConter.svg';

const Index = memo((props) => {

  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const { lang } = useSelector(({localesReducer}) => localesReducer.i18n);


  const { status, title, style, iconCss} = props.config;

  let location = useLocation();
  let navigate = useNavigate();

  const [rectangleFlag, setRectangleFlag] = useState(false);

  // 样式判断
  const normal = () => {
    if(recReSizeReducer > 1920){
      return isNormalZhEnCss(lang, 'English') ? styles.normalXl2En : styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      return isNormalZhEnCss(lang, 'English') ? styles.normalXlEn : styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      return isNormalZhEnCss(lang, 'English') ? styles.normalLgEn : styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      return isNormalZhEnCss(lang, 'English') ? styles.normalMdEn : styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      return isNormalZhEnCss(lang, 'English') ? styles.normalSmEn : styles.normalSm;
    }
  };


  const handleJump = () => {
    const { path } = props.config;
    if(path){
      navigate(path);
      if(props.handleEvent){
        props.handleEvent();
      }else{
        backTo();
      }
      
    }
  }

  const [frameIconStatus, setFrameIconStatus] = useState(false);
  const [heightVal, setHeight] = useState({
      transition: 'all .3s',
      width: `${22.5}px`,
      height: `${15}px`,
  });
  

  // rectangleFlag, setRectangleFlag
  const handleMouseMove = () => {
      setRectangleFlag(true);
      setFrameIconStatus(true);
      setHeight({
        transition: 'all .3s',
        width: recReSizeReducer <= 750 ? `${35/100}rem` : `${35}px`,
        height: recReSizeReducer <= 750 ? `${26/100}rem` : `${26}px`,
      });
  }


  const handleMouseLeave = () => {
      setRectangleFlag(false);
      setFrameIconStatus(false);
      setHeight({
        transition: 'all .3s',
        width: recReSizeReducer <= 750 ? `${(18.5*2)/100}rem` : `${22.5}px`,
        height: recReSizeReducer <= 750 ? `${(11*2)/100}rem` : `${15}px`,
      });
  }

  useEffect(() => {
    setHeight({
      transition: 'all .3s',
      width: recReSizeReducer <= 750 ? `${(18.5*2)/100}rem` : `${22.5}px`,
      height: recReSizeReducer <= 750 ? `${(11*2)/100}rem` : `${15}px`,
    });
  }, [recReSizeReducer]);

  // const isIcon = recReSizeReducer <= 750 ? frameMIcon : frameIcon;
  const isIcon = recReSizeReducer <= 750 ? frameMIcon : frameMIcon;

  const rectangleIsCss = () => {
    if(recReSizeReducer <= 750){
      return rectangleFlag ? styles.rectangleSm : styles.rectangleHoverSm;
    }else{
      return rectangleFlag ? styles.rectangle : styles.rectangleHover;
    }
  }

  const rectangleRen = () => {
    return (
      <div className={rectangleIsCss()} >
        <img className='leftTop' src={rectangleLeftTop} alt=''/>
        <img className='leftBottom' src={rectangleLeftBottom} alt=''/>
        <img className='rightTop' src={rectangleRightTop} alt=''/>
        <img className='rightBottom' src={rectangleRightBottom} alt=''/>
        <img className='conter' src={rectangleConter} alt=''/>
      </div>
    )
  } 

  return (
      <div
        ref={props.getRef ? props.getRef : null}
        className={normal()} 
        style={{...style, cursor: props.config.isCursor !== 1 ? 'pointer' : 'initial', ...props.setStyle}} 
        onClick={status ? handleJump : null}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      >
          {title ? <h3 className="title">{title}</h3> : null}
          {status ? (
              <div className="icon" style={iconCss}>
                <span>SEE MORE INFO</span>
                {/* <i style={heightVal}><img style={heightVal} src={frameIconStatus ? frameicomMax : isIcon} alt="" /></i> */}
                {recReSizeReducer <= 750 ? (<i style={heightVal}><img style={heightVal} src={frameIconStatus ? frameicomMax : isIcon} alt="" /></i> ) : rectangleRen()}
              </div>
          ) : null}
      </div>
  );
});
export default Index;
